import React, { Component } from 'react';
import { Grid, Input } from 'semantic-ui-react';
import { decamelize, printThisObjectClickable } from './util';
import _ from 'lodash';

export default class EsOutput extends Component {    
    constructor(props) {
        super(props);
        this.state = {
            "caseType": this.props.nonModalWindow?"CASE_0":null
        }
    }
    detailedCase = (e) => {
        let caseType = e.target.dataset.casetype;
        if(caseType !== this.state.caseType){
            this.setState({"caseType": caseType});
        }else{
            this.setState({"caseType": null});
        }
    }

    onSearch = (e) => {
        if(e.which === 13){
            let str = e.target.value;
            if (window.find) {
                // CODE FOR BROWSERS THAT SUPPORT window.find
                let strFound=window.find(str);
                if (!strFound) {
                    strFound=window.find(str,0,1);
                    while (window.find(str,0,1)) continue;
                }
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        let willRender = (!_.isEqual(nextProps, this.props)) || (!_.isEqual(nextState, this.state));
        return willRender
      }

    componentDidUpdate() {
        let {qryOutput, enableDisablePsc} =  this.props;
        let valid = false;
        for(let onecase of _.get(qryOutput,"responseParams.cbpESCases",[])){
            if(!onecase || !onecase.cbpEntrySummaryStatus)continue
            let liquidationstatus = (onecase.cbpEntrySummaryStatus.liquidationStatusCode+"").toLowerCase();
            if(liquidationstatus.indexOf("not liquidated")>=0){
                valid = true;
                if(this.state.liqTxtVal !== "Entry Summary Not Liquidated"){
                    this.setState({liqTxtVal: "Entry Summary Not Liquidated"})
                }
            }
        }
        enableDisablePsc(valid);
    }

    render() {
        let {qryOutput, hideDetails, loadEntrySummaryQueryState, nonModalWindow} =  this.props;
        let { liqTxtVal } = this.state;
        let result = qryOutput.responseParams;
        //object is wrong, let's move things to the correct place
        if(!result.cbpESCases && !result.fieldmessagetype){
            result.cbpESCases = [{cbpEntrySummaryStatus:result}];
            result._hideDetails = true;
        }
        hideDetails=hideDetails || result._hideDetails;
        let resultsToShow = [
        {
            title:'Last Modified', 'key': 'lastModified', id:1
        },{
            title:'Shipment Id', 'key': 'shipmentId', id:1
        },{
            title:'Entry Number', 'key': 'fullEntryNumber', id:2
        },{
            title:'Entry Summary', 'key': 'entrySummaryStatusCode', id:3
        },{
            title:'Release status', 'key': 'releaseStatus', id:4
        },{
            title:'Release date', 'key': 'releaseDate', id:5
        },{
            title:'Payment status', 'key': 'paymentStatusCode', id:6
        },{
            title:'Control status', 'key': 'entrySummaryControlStatus', id:7
        },{
            title:'Liquidation status', 'key': 'liquidationStatusCode', id:8
        }
    ];
    let humanizeResultItem = (value) =>{
        if(!value)return "";
        if(value.indexOf("$")==0){
            let minlength = 10
            let justtext = value.substring(1,999);
            let separator ="";
            while(separator.length<(minlength-justtext.length))separator+="0";
            return <React.Fragment>
                $
                <span style={{visibility:'hidden'}}>{separator}</span>
                {justtext}
            </React.Fragment>;
        }
        return value;
    }
    let isNullValue = (value) =>{
        return !value || 
        !((value+"").trim()) ||
        value == "$" || //empty money field
        value+"" == "{}"
    }
    let moredetailstext = 'More details...';
        return (
            <div id='EsOutput' className={`outputData adcvdOutput`}>
                 <Grid className={`adcvdCaseList`} >
                     {!result.cbpESCases && <React.Fragment>
                        <b>{result.fieldmessagetype}</b>: {result.fieldmessage}
                     </React.Fragment>}
                     {loadEntrySummaryQueryState && <React.Fragment>{loadEntrySummaryQueryState}<br/></React.Fragment>}
                    {
                        result.cbpESCases && result.cbpESCases.map((item, index) => {
                            let hasdetails = (item.detail && item.detail.records && !_.isEmpty(item.detail.records[0]))
                            let hasanyvaluesAtAll = true;
                            if(hideDetails){
                                hasanyvaluesAtAll = false;
                                // resultsToShow.push({
                                //     title:moredetailstext,
                                //      'key': "abc123", id:'abc123'

                                // })
                                for(let onekey of Object.keys(item.cbpEntrySummaryStatus)){
                                    if(onekey.indexOf("_")==0)continue;
                                    if(resultsToShow.find((a)=>a.key==onekey)){hasanyvaluesAtAll=true;continue;}
                                    if(onekey == 'cbpESCases')continue;
                                    resultsToShow.push({
                                        title:(onekey+"").replaceAll(/json$/gi,"")
                                        .replace(/([a-z\d])([A-Z])/g, '$1' + ' ' + '$2'),//convert from camelcase
                                         'key': onekey, id:resultsToShow.length+1

                                    })
                                }
                            }
                            return (
                             <React.Fragment key={item.cbpEntrySummaryStatus.acceptDateTime+" "+item.cbpEntrySummaryStatus.entryNumber}>
                                
                                 {this.props.launchFrom =="ESHeader" //esheader==psc
                                  && liqTxtVal &&
                                  <span style={{color:'red'}}>{liqTxtVal}</span>}
                            {(hasanyvaluesAtAll || result.msg) && <Grid.Row className={`adcvd-row`} columns={3}>
                                <Grid.Column width={16}>
                                    {((result.code == 404 || result.code == 406) && result.msg) ? 
                                        <div style={{padding:'50px'}}>Message: {result.msg}</div>
                                    :hasanyvaluesAtAll ? 
                                    <Grid style={{
                                                maxHeight: nonModalWindow?'220px':'60vh',
                                                overflowY: 'auto'}} className="force-scrollbar">
                                        {resultsToShow.map((kkresult,iiii)=>{
                                            if(kkresult.title==moredetailstext){
                                                return <Grid.Row key={kkresult.title} className={`adcvd-casenumber-row bottom-border`} >
                                                <Grid.Column className="keyName esoutputYES" width={16} style={{textAlign:'center'}}>
                                                    *&nbsp;&nbsp;&nbsp;&nbsp;*&nbsp;&nbsp;&nbsp;&nbsp;*
                                                </Grid.Column>
                                            </Grid.Row> 
                                            }
                                            const cellVal = item.cbpEntrySummaryStatus[kkresult.key];
                                            if (cellVal === "$"
                                                || cellVal === "{}"
                                                || (typeof cellVal === "string" && cellVal.trim() === "")
                                                || (typeof cellVal === "object" && _.isEmpty(cellVal))
                                                || !cellVal) {
                                                return <React.Fragment></React.Fragment>
                                            }
                                            return <Grid.Row key={kkresult.title} className={`adcvd-casenumber-row bottom-border`} columns={3}>
                                                <Grid.Column className="keyName esoutputYESt" width={5}>&nbsp;{kkresult.title}</Grid.Column>
                                                <Grid.Column width={1}></Grid.Column>
                                                <Grid.Column className="keyValue" width={10}>
                                                    { typeof cellVal == "object"?
                                                printThisObjectClickable(cellVal,kkresult.key+"jiopfgersjokpi",this)
                                                :humanizeResultItem(cellVal)}</Grid.Column>
                                            </Grid.Row> 
                                        })}
                                    </Grid>    
                                        :
                                        <div style={{padding:'50px'}}>No Results Found...</div>
                                    }
                                </Grid.Column>
                                <Grid.Column 
                                style={{position:'absolute','top':'0px',right:'20px'}} width={3}>
                                <Grid>
                                    {!hideDetails && !nonModalWindow && <Grid.Row className={`detailbtn-row`}>
                                        <Grid.Column>
                                        <span className={`btn runAgainBtn`} data-caseType={`CASE_${index}`} style={{"width":"112px"}} onClick={this.detailedCase}>Show More</span>
                                        </Grid.Column>
                                    </Grid.Row>}
                                    <Grid.Row className={`selectcasebtn-row`}>
                                        <Grid.Column>
                                        {
                                            this.props.selectCase && 
                                            <span className={`btn runAgainBtn`} style={{"width":"112px"}} onClick={()=>{
                                                // debugger;
                                                this.props.selectCase({
                                                    "caseData": {
                                                        "adValoremRate": item.adValoremRate || "",
                                                        "caseNo": item.caseNo || "",
                                                        "cashBondIndicator": item.cashBondIndicator || ""
                                                    }
                                                })
                                                this.props.closeModal()
                                            }}>Select Case</span>
                                        }    
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            }
                            {
                                // <Grid.Row className={`adcvd-casenumber-row-header ${(this.state.caseType == 'CASE_'+index)? 'showCase': 'hideCase'}`} columns={3}>
                                //     <Grid.Column className="keyName" width={8}></Grid.Column>
                                //     <Grid.Column width={5}>
                                //         <Input type='search' onKeyPress={this.onSearch} name='searchData'/><i class="search icon"></i>
                                //     </Grid.Column>
                                //     <Grid.Column width={3}><div className={`btn runAgainBtn`}>Select Query</div></Grid.Column>
                                // </Grid.Row> 
                            }
                            {!hideDetails && <React.Fragment>
                            {
                                hasdetails ? item.detail.records.map((_item, _index) => (
                                    <Grid.Row id={`CASE_ROW_${index}`} className={`adcvd-detailed-casenumber-row ${(this.state.caseType === 'CASE_'+index)? 'showCase': 'hideCase'}`} columns={2}>
                                        <Grid.Column width={16}>
                                            <Grid>
                                                <Grid.Row className={`adcvd-casenumber-row blueBorder bottom`} columns={1}>
                                                    <Grid.Column className="caseTypeHeading">{_item.name} </Grid.Column>
                                                </Grid.Row>
                                                {
                                                    _item.values && _item.values.map((__item, __index) => {
                                                        if(!__item || isNullValue(__item.value))return(<React.Fragment></React.Fragment>);
                                                        return (
                                                        <Grid.Row className={`adcvd-casenumber-row bottom-border`} columns={3}>
                                                            <Grid.Column className="keyName esoutputYESq" width={5}>{decamelize(__item.key)}</Grid.Column>
                                                            <Grid.Column width={1}></Grid.Column>
                                                            <Grid.Column className="keyValue" width={10}>{__item.value}</Grid.Column>
                                                        </Grid.Row>
                                                    )})
                                                }
                                            </Grid>    
                                        </Grid.Column>
                                    </Grid.Row>
                                )) :  <Grid.Row id={`CASE_ROW_${index}`} className={`adcvd-detailed-casenumber-row ${(this.state.caseType == 'CASE_'+index)? 'showCase': 'hideCase'}`} columns={1}>
                                    <Grid.Column style={{"textAlign":"center", "marginTop": "20px", "fontWeight": "bold", "width": "100%"}}>Not a valid Detail</Grid.Column>
                                    </Grid.Row>
                            }
                            {/*end hideDetails*/}</React.Fragment>}
                             </React.Fragment>
                        )})  
                    }
                </Grid> 
            </div>
        )
    }
}